import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as nhaCungCapAction from './actions'
import * as nhaCungCapConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class NhaCCEdit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    nhaCungCapUpdateRequest: PropTypes.func,
    nhaCungCapDetailRequest: PropTypes.func,
    nhaCungCapListRequest: PropTypes.func,
    nhaCungCapEdit: PropTypes.shape({
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        IsDeleted: -1,
        StoresId: dbContext.getStoreId(),
      },
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChangeTrim = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value.trim()
    this.setState({ item })
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.IsDeleted = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { nhaCungCapDetailRequest } = this.props
    let nhaCungCapId = this.getParam("ncc");
    var requestData = {
      NhaCungCapId: nhaCungCapId || 0
    }
    return nhaCungCapDetailRequest(requestData);
  }
  UpdateNhaCungCap = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên nhà cung cấp';
    }
    if (!this.state.item.Ma || this.state.item.Ma == "") {
      formError.Ma = 'Bạn chưa nhập mã nhà cung cấp';
    }
    if (!this.state.item.DiaChi || this.state.item.DiaChi == "") {
      formError.DiaChi = 'Bạn chưa nhập địa chỉ';
    }
    if (!this.state.item.NhanVienKd || this.state.item.NhanVienKd == "") {
      formError.NhanVienKd = 'Bạn chưa nhập nhân viên kinh doanh';
    }
    if (!this.state.item.DienThoai || this.state.item.DienThoai == "") {
      formError.DienThoai = 'Bạn chưa nhập số điện thoại';
    }
    if (!this.state.item.SoDienThoaiNv || this.state.item.SoDienThoaiNv == "") {
      formError.SoDienThoaiNv = 'Bạn chưa nhập số điện thoại nhân viên';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      this.props.nhaCungCapUpdateRequest(item);
    }
  }
  BackToListnhaCungCap = (item, e) => {
    this.props.history.push('/nhacungcap');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nhaCungCapEdit.type == nhaCungCapConstant.NHACUNGCAP_DETAIL_SUCCESS) {
      let { item } = nextProps.nhaCungCapEdit;
      if (item.NhaCCId && item.NhaCCId > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.nhaCungCapEdit.type == nhaCungCapConstant.NHACUNGCAP_UPDATE_SUCCESS) {
      this.props.history.push("/nhacungcap");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      nhaCungCapEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-6">
              <Label >Mã nhà cung cấp<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="Ma" placeholder="Mã nhà cung cấp" value={item.Ma || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.Ma}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Tên nhà cung cấp<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="Ten" placeholder="Tên nhà cung cấp" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Địa chỉ<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="DiaChi" placeholder="Địa chỉ" value={item.DiaChi || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.DiaChi}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Điện thoại<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="DienThoai" placeholder="Điện thoại" value={item.DienThoai || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.DienThoai}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Nhân viên kinh doanh<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="NhanVienKd" placeholder="Nhân viên kinh doanh" value={item.NhanVienKd || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.NhanVienKd}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Số điện thoại nhân viên<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="SoDienThoaiNv" placeholder="Số điện thoại nhân viên" value={item.SoDienThoaiNv || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.SoDienThoaiNv}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Giám sát kinh doanh</Label>
              <Input type="text" name="GiamSatKd" placeholder="Giám sát kinh doanh" value={item.GiamSatKd || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.GiamSatKd}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Số điện thoại giám sát</Label>
              <Input type="text" name="SoDienThoaiGs" placeholder="Số điện thoại giám sát" value={item.SoDienThoaiGs || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.SoDienThoaiGs}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label>Email</Label>
              <Input type="text" name="Email" placeholder="Email" value={item.Email || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Email}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Ngành hàng</Label>
              <Input type="text" name="NganhHang" placeholder="Ngành hàng" value={item.NganhHang || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
            <FormGroup className="col-sm-12">
              <Label for="descriptionText">Ghi chú</Label>
              <Input type="textarea" name="GhiChu" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListnhaCungCap()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateNhaCungCap()}
              permission={BtnPermissions.NhaCungCap.ADD_OR_UPDATE} />
            {/* <ButtonExt btnClass="mr-1"
              color="secondary"
              iconClass="fa-close"
              displayText="Hủy"
              btnClick={() => this.Cancel()}
              permission={""} /> */}
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nhaCungCapEdit: state.nhaCungCapEdit,
})
const connected = connect(mapStateToProps, {
  nhaCungCapDetailRequest: nhaCungCapAction.nhaCungCapDetailRequest,
  nhaCungCapUpdateRequest: nhaCungCapAction.nhaCungCapUpdateRequest,
  nhaCungCapListRequest: nhaCungCapAction.nhaCungCapListRequest,
})(NhaCCEdit)

const formed = reduxForm({
  form: 'nhaCungCapEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/NhaCC/NhaCCEdit.js